import { CabinetKtruRequestsAPIService } from '@/services/backend/cabinet/ktru/ktru-requests';
import { CabinetKtruFavoritesAPIService } from '@/services/backend/cabinet/ktru/ktru-favorites';

export const ktru = {
    ktruRequests: new CabinetKtruRequestsAPIService(),
    ktruFavorites: new CabinetKtruFavoritesAPIService()
};
